import { createFileRoute } from '@tanstack/react-router';
import { InstructorDashboardPage } from '@pages/instructor';

/**
 * Instructor Dashboard Page
 *
 * Route: /:locale/instructor/dashboard
 */
export const Route = createFileRoute('/$locale/_authenticated/instructor/dashboard')({
  component: InstructorDashboard,
});

function InstructorDashboard() {
  return <InstructorDashboardPage />;
}
